import React from 'react';
import s from './ButtonsCommonStyles.module.css';
const ButtonPlusElement = () => {
	return <span className={s.whitePlusContainer}>+</span>;
};

export default ButtonPlusElement;
